'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.component = exports.NOTICE_LS_KEY = exports.NOTICE_COOKIE_NAME = undefined;

var _dekuRedux = require('@viskan/deku-redux');

var _store = require('store2');

var _store2 = _interopRequireDefault(_store);

var _componentCookie = require('component-cookie');

var _componentCookie2 = _interopRequireDefault(_componentCookie);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOTICE_COOKIE_NAME = exports.NOTICE_COOKIE_NAME = 'vs-closed-notice';
var NOTICE_LS_KEY = exports.NOTICE_LS_KEY = 'vs-closed-notice-components';

var component = exports.component = (0, _dekuRedux.connect)(function (state, _ref) {
	var id = _ref.id;
	return {
		cmsActive: state.streamlineCms.loaded && !state.cms.base.hidden,
		noticeStateSession: _store2.default.session(NOTICE_LS_KEY) || [],
		noticeStateCookie: Boolean((0, _componentCookie2.default)(NOTICE_COOKIE_NAME + '-' + id))
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };